module.exports = __webpack_public_path__ + "static/media/MiddleBottomIcon.964ccde7.svg";